import { useQuery, QueryFunction } from 'react-query';
import { getAllTrucksTypes, GetTrucksTypesQueries, TruckType } from '../../services/apiSLTP/materials/trucksTypes';

type UseTrucksTypesQueryOptions = {
    queries?: GetTrucksTypesQueries;
};

const getTrucksTypes: QueryFunction<TruckType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTrucksTypesQueryOptions];
    const { queries } = options;

    const response = await getAllTrucksTypes(queries);
    return response.data;
};

export const useTrucksTypesQuery = (options: UseTrucksTypesQueryOptions) => {
    return useQuery(['trucksTypes', options], getTrucksTypes);
};
